import { useCallback, useEffect, useRef, useState } from 'react';

import { isEmbeddedOpenChatAtom, useSetValue } from '@/store';

import { ChatWrapper } from './ChatScreen.styles';
import { getSayWhattConfig } from './config';
import { ApiAppParams } from '@typings/apiApp';

const isDEV = window.location.href.indexOf('localhost') > -1;

export const ChatScreen = ({ visible, message, onSend, onMessageReady, onReset }: { visible: boolean, message: string; onSend: () => void, onMessageReady: () => void, onReset: () => void }) => {
  const [key, setKey] = useState<number>(0);
  const setIsChatOpen = useSetValue(isEmbeddedOpenChatAtom);
  const isFirstMessageSent = useRef(false);
  const isSubscribed = useRef(false);

  const initSayWhatt = useCallback(() => {
    window.sayWhattChat.init({
      ...getSayWhattConfig(isDEV),
      onResetChat: () => {
        onReset();
        window?.sayWhattChat?.destroy();
        isFirstMessageSent.current = false;
        isSubscribed.current = false;
        setKey((prevState) => prevState + 1);
      },
      onMessageReady: () => {
        onMessageReady();
      },
      onWSSubscribed: () => {
        isSubscribed.current = true;
      }
    } as ApiAppParams);
  }, [onMessageReady, onReset])

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    const interval = setInterval(() => {
      if (window?.sayWhattChat) {
        clearInterval(interval);

        initSayWhatt();

        timer = setTimeout(() => {
          if (!isSubscribed.current) {
            window?.sayWhattChat?.resetChat();
          }
        }, 4000);
      }
    }, 50);

    return () => {
      clearInterval(interval);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [initSayWhatt, key]);

  useEffect(() => {
    if (!visible || !message.length || isFirstMessageSent.current) {
      return;
    }
    isFirstMessageSent.current = true;
    window?.sayWhattChat?.sendNewMessage(message);
    onSend();
  }, [visible, message, onSend]);

  useEffect(() => {
    if (visible) {
      setIsChatOpen(true);
    }
  }, [visible]);

  return (
    <ChatWrapper visible={visible}>
      <div id="saywhatt-outlet" key={key} style={{ height: '100%' }}></div>
    </ChatWrapper>
  )
};